import React from 'react';
import { MonitorPlay, Gamepad2, BookOpenCheck, ClipboardCheck, BarChart3, ShieldCheck, LogIn } from 'lucide-react';
import { Card, ReadMore } from '../ui';

const BLOCKS = [
  [MonitorPlay, 'Oltre 1.000 contenuti pronti', 'Moduli interattivi, video con domande di verifica, newsletter e pillole formative brevi, disponibili in 22 lingue: le campagne partono subito, senza produrre materiale.'],
  [Gamepad2, 'Formazione coinvolgente', 'Videogiochi, fumetti e classifiche trasformano la sicurezza in un\'esperienza che i dipendenti seguono volentieri, con contenuti aggiornati anche sull\'uso sicuro dell\'intelligenza artificiale.'],
  [BookOpenCheck, 'Percorsi su misura', 'Corsi con contenuti in sequenza, scelti dal catalogo o costruiti con i materiali dell\'azienda, assegnati per reparto o ruolo.'],
  [ClipboardCheck, 'Esami e sondaggi', 'Test con soglia di superamento per misurare il livello di conoscenza e questionari per raccogliere il riscontro dei partecipanti.'],
  [BarChart3, 'Report e indice di rischio', 'Cruscotto con avanzamento, punteggio di rischio per persona e reparto e confronto con la media del settore.'],
  [ShieldCheck, 'Conformità NIS2 e GDPR', 'Contenuti collegati a NIS2, GDPR e ISO/IEC 27002: la formazione svolta è documentata e dimostrabile in caso di controllo.'],
];

export default function TrainingPresentation() {
  return (
    <Card className="p-6 mb-6" data-testid="training-presentation">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Piattaforma di security awareness</p>
          <h2 className="font-heading text-lg mb-2">Il fattore umano è la prima difesa: allenalo</h2>
          <p className="text-sm text-[#A3A3A3]">Una piattaforma completa per formare e sensibilizzare il personale sulla sicurezza informatica. Smart Info la attiva, pianifica le campagne e ti consegna i risultati.</p>
        </div>
        <div className="text-right">
          <a href="https://smartinfo.takesecurity.com/" target="_blank" rel="noreferrer" className="h-10 px-5 text-sm rounded-sm inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#E6C547] text-[#050505] font-semibold transition-colors" data-testid="training-platform-login">
            <LogIn size={15} />Accedi alla piattaforma</a>
          <p className="text-xs text-[#7A7F87] mt-1.5" data-testid="training-platform-soon">Si apre in una nuova scheda</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {BLOCKS.map(([Icon, t, d], i) => (
          <div key={t} className="border border-[#1F242C] rounded-sm p-4 hover:border-[#D4AF37]/60 transition-colors" data-testid={`training-block-${i}`}>
            <Icon size={18} className="text-[#D4AF37] mb-3" />
            <p className="text-sm font-semibold mb-1">{t}</p>
            <ReadMore clamp="max-sm:line-clamp-2" className="text-sm text-[#A3A3A3] leading-relaxed">{d}</ReadMore>
          </div>
        ))}
      </div>
    </Card>
  );
}
